// this file is generated by update_shopify_store_data.py at 2026-11-03 20:14:09.358791
var courses = [
    {
        "course_id": "C07BB4CD-A88C-EB11-80E0-005056B11C93",
        "course_version": 4,
        "name": "Communication: Healthcare Essentials",
        "course_type": 1,
        "author_information": "The content from this activity was originally written by a team of writers, subject matter experts, and clinicians from HealthStream. The planning committee has reviewed this updated content and determined it to be appropriate for inclusion in this activity.",
        "description": "This learning activity addresses the fundamentals of communication and discusses practical strategies for healthcare professionals to communicate successfully with individuals receiving care and their support people.",
        "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Identify the definition of communication and the communication process.</li>\r\n    <li>Differentiate verbal, non-verbal, and para-verbal communication.</li>\r\n    <li>Recognize communication strategies for different situations.</li>\r\n    <li>Specify techniques for empathetic listening.</li>\r\n</ul>\r\n<p><strong>Activity Planners and Authors</strong></p>\r\n<ul>\r\n    <li>Bethany Chism, RN, MS, MSN</li>\r\n    <li>Katelyn Roche, MS, RN, CCRN</li>\r\n    <li>Donita Jacobs, MSN, RN, NI-BC</li>\r\n    <li>Amanda Pitt, MBA, BSN, RN, RN-BC (Nurse Planner)</li>\r\n    <li>Evan McEwing, DNP, PHNA-BC, RN, CCRP, CHSE, Sr. Director, Content Development and Research, HealthStream (AP-PD)</li>\r\n    <li>Jessica Ellis, RN, BSN, Director, Content Development, HealthStream (Content Reviewer)</li>\r\n    <li>Germaine Broussard, B.S., Sr. Development Manager, HealthStream (Content Reviewer)</li>\r\n    <li>CorShun Thurman, B.A., Accreditation Specialist, HealthStream</li>\r\n</ul>\r\n<p>None of the planners for this educational activity have relevant financial relationship(s) to disclose with ineligible companies whose primary business is producing, marketing, selling, re-selling, or distributing healthcare products used by or on patients.</p>\r\n<p><strong>Commercial Support</strong></p>\r\n<p>This activity was not commercially supported.</p>\r\n<p><strong>Criteria for Completion</strong></p>\r\n<p>This activity contains a post-test and reflective/interactive content. You must complete the entire activity, including the evaluation, and score an 80% or higher on the post-test in order to obtain a certificate of completion. Partial credit will not be given.</p>\r\n<p>Licensees must provide their license/member numbers for record keeping purposes. Continuing education licensing/certification requirements vary by profession and state. Learners should contact their licensing/certification board or professional organization to confirm that these contact hours will be accepted. HealthStream does not warrant acceptance.</p>\r\n<p><strong>CE Release &amp; Expiration Dates</strong></p>\r\n<p><strong>ANCC</strong></p>\r\n<p>Release Date: 10-01-2026</p>\r\n<p>Expiration Date: 09-30-2029</p>\r\n<p><strong>Content Review:</strong></p>\r\n<p>All HealthStream accredited content is continuously reviewed to ensure alignment with current standards of care.</p>",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Communication Overview</li>\r\n    <li>Communication Options and Strategies</li>\r\n    <li>Empathetic Listening</li>\r\n    <li>Conclusion and References</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F74B0A8-CB5D-EC11-80EC-005056B142B5",
                "course_category_name": "HSTM - Care Essentials: Rehabilitation, Occupational and Physical Therapy [Manage Subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7FEA2588-4ADB-EB11-80E2-005056B108B1",
                "course_category_name": "HSTM - Care Essentials [Manage Subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Personal Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C92075A2-DA5D-EC11-80EC-005056B142B5",
                "course_category_name": "HSTM - Care Essentials: Service Excellence [Manage Subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFF0FB5D-3C6A-EB11-80DE-005056B134EC",
                "course_category_name": "True Vector (Aspenti) - Care Essentials",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3B158BA2-D74F-ED11-80F6-005056B16B79",
                "course_category_name": "Public Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6584F77B-AB48-EC11-80E9-005056B16B79",
                "course_category_name": "HSTM - Care Essentials: Behavioral Health [Manage Subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6F2D23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Customer Service",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7361099E-5649-EC11-80EB-005056B13D3F",
                "course_category_name": "HSTM - Care Essentials: Management [Manage Subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FA1EE78C-235A-ED11-80F7-005056B10BDD",
                "course_category_name": "NurseGrid Learn - Unlimited CE Library (subscription) (Publish with CPP)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5AC718D0-4CCE-4066-9398-56DBED0B6FC7",
                "course_category_name": "PMH-BC: Psych/Mental Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "72C9CD80-B0CA-48B7-88EB-C724D34E742C",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Interpersonal Relationships",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AF4AB43F-6BEE-44BE-B338-B1F053B19B08",
                "course_category_name": "RN-BC: Medical-Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6C218610-7240-4D4C-85B1-5A1B4043886C",
                "course_category_name": "RN-BC: Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "99B96B09-77CF-EF11-9993-005056A7D0C4",
                "course_category_name": "CCMA: Certified Clinical Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "37A67743-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Interactions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "162D7419-F1DE-4896-A447-ED5F2D41A1C1",
                "course_category_name": "CMSRN: Medical-Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "56E42FE4-B42A-4528-8110-D8B9AC9D602B",
                "course_category_name": "RN-BC: Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B30B4D62-168A-E511-A452-005056B12710",
                "course_category_name": "Patient Satisfaction",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B2501C7D-77CF-EF11-9993-005056A7D0C4",
                "course_category_name": "CNA: Certified Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8A98D6C7-35DB-EB11-80E2-005056B108B1",
                "course_category_name": "HSTM - Care Essentials",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "AAPT; ANCC; BON-CNA",
            "accreditation_statement": "<span style=\"font-family: Calibri;\">For licensed professionals who use CE Broker: HealthStream will automatically report your completion to CE Broker <em><span style=\"text-decoration: underline;\">if your licensing board is listed</span></em>. You must enter your license number, state, and discipline in your HealthStream profile for successful reporting. Other professionals may self-report the completion, if appropriate. </span>\r\n<p><img width=\"136\" height=\"115\" style=\"width: 136px; height: 115px;\" alt=\"HealthStream Reports to CE Broker within 24hrs\" src=\"https://www.healthstream.com/content/_CEBroker/CEBrokerReportsBadge-24Hrs.png\" /></p>",
            "course_level_accreditation_statement": "<p><strong>American Association of Psychiatric Technicians (AAPT)</strong></p>\r\n<p>HealthStream is an AAPT Continued Education Provider.</p>\r\n<p><strong>Nurses</strong></p>\r\n<p>HealthStream CNE Provider Unit is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.  ANCC Provider Number: P0088</p>\r\n<p>This activity is awarded 1.25 contact hour(s); 0.00 contact hours are in the area of pharmacology.</p>\r\n<p>HealthStream maintains active CE Broker reporting relationships for all participating state boards of medicine and state boards of nursing that utilize CE Broker and accept continuing education activities provided through HealthStream's ANCC-accredited nursing education and ACCME-accredited continuing medical education programs. HealthStream reports learner completions in accordance with applicable state board and CE Broker requirements. Click here for a list of CE Broker boards: <a href=\"https://help.cebroker.com/hc/en-us/articles/15226513719572-Boards-and-Regulating-Entities-Working-with-CE-Broker\">Boards and Regulating Entities Working with CE Broker &ndash; CE Broker</a></p>\r\n<p>CE Broker Tracking Number: 50-907</p>\r\n<p>Course Number: 20-1403107 Category: General</p>\r\n<p>*Please note: Some boards will round the reported contact hours to the nearest 0.5 hour.</p>\r\n<p><strong>Certified Nursing Assistants (CNAs)</strong></p>\r\n<p>Contact Hours: 1.25</p>\r\n<p><strong>State Nursing Boards-Certified Nursing Assistants</strong></p>\r\n<p>Florida Board of Nursing-Certified Nursing Assistants</p>\r\n<p>CE Broker Tracking Number: 50-907</p>\r\n<p>Course Number: 20-1403107 Category: General</p>\r\n<p>*Please note: Some boards will round the reported contact hours to the nearest 0.5 hour.</p>",
            "credit_display_name": "AAPT; ANCC; BON-CNA",
            "credit_units": 1.25,
            "credit_unit_display_name": "CEU; CNE; CE"
        },
        "sub_courses": []
    }
];